import { Button, Icon } from "semantic-ui-react";

import { useAppointmentWidget, useCarWidget } from "components/PSA/hooks";

import type { DealerLocation } from "models";

type PSAProps = {
  id: number;
  type: "car" | "appointment";
  location?: DealerLocation;
};

export const PSA = ({ id, type, location }: PSAProps) => {
  const isWoWidgetVisible = type === "appointment" && (location?.service_box_visible_on_wo ?? false);
  const isCarWidgetVisible = type === "car" && (location?.service_box_visible_on_car ?? false);

  const { data: appointmentWidget } = useAppointmentWidget(id, isWoWidgetVisible);
  const { data: carWidget } = useCarWidget(id, isCarWidgetVisible);

  const handleOpenPSALink = () => {
    if (type === "appointment" && appointmentWidget?.redirect_url) window.open(appointmentWidget.redirect_url, "_blank");
    else if (type === "car" && carWidget?.redirect_url) window.open(carWidget.redirect_url, "_blank");
  };

  const handleOpenXentryLink = () => appointmentWidget?.service_box_wo_2 && window.open(appointmentWidget.service_box_wo_2, "_blank");

  const shouldDisplayWoWidgetButton = isWoWidgetVisible && appointmentWidget?.redirect_url;
  const shouldDisplayCarWidgetButton = isCarWidgetVisible && carWidget?.redirect_url;
  const shouldDisplayXentryButton = isWoWidgetVisible && appointmentWidget?.service_box_wo_2;

  if (!shouldDisplayWoWidgetButton && !shouldDisplayCarWidgetButton && !shouldDisplayXentryButton) return null;

  return (
    <>
      <Button className="-appointment-status" size="small" onClick={handleOpenPSALink}>
        {appointmentWidget?.button_label || carWidget?.button_label || "S"}
        <Icon className="arrow up right from square" color="green" />
      </Button>

      {shouldDisplayXentryButton && (
        <Button className="-appointment-status" size="small" onClick={handleOpenXentryLink}>
          {appointmentWidget.service_box_wo_2_name || "X"}
          <Icon className="arrow up right from square" color="green" />
        </Button>
      )}
    </>
  );
};
